import React, { useState } from 'react';
import '../registration/searchPopupDesign.css';

const SearchPopup = ({ searchType, targetInputId, apiUrl, onClose }) => {
    const [query, setQuery] = useState('');
    const [sortBy, setSortBy] = useState('Sort by ID');
    const [results, setResults] = useState([]);

    const handleSearch = async () => {
        if (!query.trim()) {
            alert("Please enter a search term.");
            return;
        }

        try {
            const token = localStorage.getItem("jwt");
            const response = await fetch(`${apiUrl}?query=${encodeURIComponent(query)}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const data = await response.json();
            setResults(sortResults(data, sortBy));
        } catch (error) {
            console.error("Search error:", error);
            alert("Failed to fetch search results.");
        }
    };

    const sortResults = (results, sortBy) => {
    return results.sort((a, b) => {
        if (sortBy === "Sort by ID") return (a.id || 0) - (b.id || 0);
        if (sortBy === "Sort by Name") return (a.name || "").localeCompare(b.name || "");
        if (sortBy === "Sort by Username") return (a.username || "").localeCompare(b.username || "");
        return 0;
    });
};


    const handleSelect = (id, name) => {
        window.opener?.postMessage({ target: targetInputId, value: id, displayName: name }, "*");
        onClose();
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>Search {searchType}</h2>

                <input
                    type="text"
                    placeholder="Search by Name, Username..."
                    className="search-input"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />

                <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    style={{ marginBottom: '10px', padding: '10px', width: '85%' }}
                >
                    <option>Sort by ID</option>
                    <option>Sort by Name</option>
                    <option>Sort by Username</option>
                </select>

                <button className="search-button" onClick={handleSearch}>Search</button>

              <ul className="results-list">
  {results.map((result) => {
    const fullName =
      result.name || `${result.firstName || ''} ${result.lastName || ''}`.trim();

    const username = result.username ? ` (@${result.username})` : '';
    const displayText = `${fullName || 'Unnamed'}${username}`;

    return (
      <li
        key={`item-${result.id}-${result.username || ''}`}
        onClick={() => handleSelect(result.id, fullName)}
      >
        {displayText}
      </li>
    );
  })}
</ul>

                <button className="close-button" onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default SearchPopup;
